import React from "react";
import { Box, Typography } from "@mui/material";
const Error: React.FC<{ error: string }> = ({ error }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        px: 3,
        height: "80vh",
        color: "error.main",
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          display: "grid",
          placeItems: "center",
          mb: 1.5,
          borderRadius: "16px",
          bgcolor: "rgba(229, 72, 77, 0.12)",
          fontSize: 28,
          fontWeight: 800,
        }}
      >
        !
      </Box>
      <Typography variant="h6">{error}</Typography>
    </Box>
  );
};
export default Error;
